import { useState, useCallback } from "react";
import { toastService } from "../../../../providers";
import {
  useActivateUserMutation,
  useDeactivateUserMutation,
} from "../../../../hooks/queries/useProfileQueries";

export const useUserStatusHandlers = () => {
  const [loadingIds, setLoadingIds] = useState(new Set());

  const { mutate: ActivateUser } = useActivateUserMutation();
  const { mutate: DeActivateUser } = useDeactivateUserMutation();

  const handleToggleStatus = useCallback(
    (user) => {
      const userId = user.id;
      const isCurrentlyActive = !user.accountLocked;

      setLoadingIds((prev) => new Set(prev).add(userId));

      const onSettled = () => {
        setLoadingIds((prev) => {
          const copy = new Set(prev);
          copy.delete(userId);
          return copy;
        });
      };

      if (isCurrentlyActive) {
        DeActivateUser(userId, {
          onSuccess: () => {
            toastService.success("User deactivated successfully!");
            onSettled();
          },
          onError: () => {
            toastService.error("Failed to deactivate user");
            onSettled();
          },
        });
      } else {
        ActivateUser(userId, {
          onSuccess: () => {
            toastService.success("User activated successfully!");
            onSettled();
          },
          onError: () => {
            toastService.error("Failed to activate user");
            onSettled();
          },
        });
      }
    },
    [ActivateUser, DeActivateUser],
  );

  return {
    loadingIds,
    handleToggleStatus,
  };
};

export default useUserStatusHandlers;
